import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import footerlogoSrc from "../../../../../Image/Meepl_new_logo with text png.png";
import { ConvertDate, getUserData } from '../../../Base/helper/baseFunctions';


const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        paddingTop: 10,
        paddingBottom: 30,
        paddingHorizontal: 10,
    },
    header: {
        marginBottom: 30,
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#8b44ff',
        color: "white"
    },
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 2,
        position: 'relative',
        borderBottom:"1px solid #000",
        marginBottom:"10px"
    },

    logoContainer1: {
        width: 80,
        alignItems: 'flex-start',
        paddingLeft: 5,
    },
    rightHead: {
        width: 80,
        alignItems: 'flex-start',
    },

    logo1: {
        height: 60,
        objectFit: "contain",
    },

    centeredTextWrapper: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },

    companyNameLabel: {
        fontSize: 16,
        fontWeight: 900,
        color: "#000",
        textAlign: 'center',
    },


    addressContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 20,
        paddingHorizontal: 2
    },
    address: {
        width: '100%',
    },
    addressContent: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: 2,
    },

    addressLabel: {
        fontSize: 10,
        marginBottom: 2,
        width: '25%',
        textAlign: 'left'
    },

    addressValue: {
        fontSize: 10,
        marginBottom: 2,
        width: '75%',
        textAlign: 'left',
        paddingLeft: 5
    },
    colonSeparator: {
        fontSize: 10,
        marginRight: 5,
        marginBottom: 2,
    },
    logoContainer: {
        width: '30%',
    },
    logo: {
        width: 60,
        height: 60,
    },
    metaContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 15,
    },
    meta: {
        width: '30%',
    },
    metaLabel: {
        fontSize: 10,
        fontWeight: 'bold',
        marginBottom: 2,
    },
    metaValue: {
        fontSize: 10,
    },
    tableContainer: {
        marginBottom: 30,
        paddingHorizontal: 2
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#eaeaea',
        padding: 5,
        marginBottom: 2,
    },
    columnHeader: {
        width: '22%',
        fontSize: 10,
        flexShrink: 0,
        textAlign: 'left',
    },
    tableBody: { padding: 5 },
    tableRow: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
    },
    tableCell: {
        width: '22%',
        fontSize: 10,
        flex: 1,
        textAlign: 'left',
    },
    balanceContainer: {
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        textAlign: "right",
        paddingHorizontal: 2
    },
    balance: {
        width: '30%',
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginBottom: 5,
        textAlign: "right",
    },
    balanceLabel: {
        flex: 1,
        fontSize: 10,
        fontWeight: 'bold',
        marginBottom: 2,
        textAlign: "right"
    },
    balanceValue: {
        flex: 1,
        fontSize: 10,
        marginBottom: 2,
        textAlign: "right"
    },
    addressLabel1: {
        fontSize: 10,
        marginBottom: 2,
        width: '40%',
        textAlign: 'left',
        paddingLeft: "80px"
    },

    addressValue1: {
        fontSize: 10,
        marginBottom: 2,
        width: '60%',
        textAlign: 'left',
        paddingLeft: "80px",
        marginLeft: -15
    },
    footer1: {
        position: 'absolute',
        bottom: 10,
        left: 10,
        right: 10,
        textAlign: 'center',
        fontSize: 10,
        color: '#000',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: "1px solid #000",
        paddingTop: "5px",
        marginTop: "10px"
    },
    footerPowered: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: "5px"
    },
    footerLogo: {
        height: 15,
        objectFit: "contain",
        marginLeft: 5,
    },

});

const AtsInvoicePdf = ({ data, invoiceCandidateData, performadata, performaCandidateData, amountData, getAmount, today, companylogo, letterHeadData, orgConfigData }) => {
    const userData = getUserData();
    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    const toWordsDynamic = (num) => {
        if (num === 0) return "Zero";

        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];

        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

        const convert = (n) => {
            if (n < 20) return ones[n];

            if (n < 100) {
                return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
            }

            if (n < 1000) {
                return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + convert(n % 100) : "");
            }

            if (n < 100000) {
                return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 !== 0 ? " " + convert(n % 1000) : "");
            }

            if (n < 10000000) {
                return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 !== 0 ? " " + convert(n % 100000) : "");
            }

            return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 !== 0 ? " " + convert(n % 10000000) : "");
        };

        return convert(num);
    };
    return (
        <Document>
            <Page style={styles.page}>
                {(companylogo || letterHeadData?.letterhead_header) && (
                    <View style={styles.headerContainer} fixed>
                        <View style={styles.logoContainer1}>
                            {companylogo && (
                                <Image style={styles.logo1} src={companylogo} />
                            )}
                        </View>
                        <View style={styles.centeredTextWrapper}>
                            {letterHeadData?.letterhead_header && (
                                <Text style={styles.companyNameLabel}>
                                    {letterHeadData.letterhead_header}
                                </Text>
                            )}
                        </View>
                        <View style={styles.rightHead} />
                    </View>
                )}
                <View style={styles.header}>
                    <Text style={styles.title}>{performaCandidateData ? "Proforma" : "Invoice"}</Text>
                </View>
                <View style={styles.addressContainer}>
                    {data ?
                        <>
                            <View style={styles.address}>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Bill To</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{data?.billing_name || "NA"}</Text>
                                </View>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Billing Address</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{data?.billing_address || "NA"}</Text>
                                </View>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>GST No.</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{data?.gst_number || "NA"}</Text>
                                </View>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>PO No.</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{data?.po_number || "NA"}</Text>
                                </View>
                            </View>
                            <View style={[styles.address, {paddingLeft: 20}]}>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Invoice Date</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{ConvertDate(data?.invoice_date) || "NA"}</Text>
                                </View>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Invoice No</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{data?.ats_invoice_no || "NA"}</Text>
                                </View>
                               {!data?.gst_breakup?.gst_applicable && <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>LUT Ref</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{data?.lut_ref_no || "NA"}</Text>
                                </View>}
                            </View>
                        </> :
                        <>
                            <View style={styles.address}>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Bill To</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{performadata?.billing_name || "NA"}</Text>
                                </View>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Billing Address</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{performadata?.billing_address || "NA"}</Text>
                                </View>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>GST No.</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{performadata?.gst || "NA"}</Text>
                                </View>
                            </View>
                            <View style={[styles.address, {paddingLeft: 20}]}>
                                <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>Proforma Date</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{ConvertDate(today) || "NA"}</Text>
                                </View>
                                {!amountData?.[0]?.gst_applicable && <View style={styles.addressContent}>
                                    <Text style={styles.addressLabel}>LUT Ref</Text>
                                    <Text style={styles.colonSeparator}>:</Text>
                                    <Text style={styles.addressValue}>{performadata?.lut_ref_no || "NA"}</Text>
                                </View>}
                            </View>
                        </>}
                </View>
                <View style={styles.tableContainer}>
                    <View style={styles.tableHeader}>
                        {data ?
                            <>
                                <Text style={styles.columnHeader}>Candidate Name</Text>
                                <Text style={styles.columnHeader}>Job Title</Text>
                                <Text style={{width: '12%', fontSize: 10, textAlign: 'left', flexShrink: 0}}>Job Location</Text>
                                <Text style={{width: '16%', fontSize: 10, textAlign: 'left', flexShrink: 0}}>Joined Date</Text>
                                <Text style={{ width: '12.5%', textAlign: 'right', fontSize: 10, flexShrink: 0, fontWeight: "bold" }}>Billable CTC</Text>
                                <Text style={{ width: '15.5%', textAlign: 'right', fontSize: 10, flexShrink: 0, fontWeight: "bold" }}>Billable Amount</Text>
                            </> :
                            <>
                                <Text style={{width: '17%', fontSize: 10, textAlign: 'left', flexShrink: 0, fontWeight: "bold" }}>Candidate Name</Text>
                                <Text style={{width: '20%', fontSize: 10, textAlign: 'left', flexShrink: 0, fontWeight: "bold" }}>Job Title</Text>
                                <Text style={{width: '11%', fontSize: 10, textAlign: 'left', flexShrink: 0, fontWeight: "bold" }}>Job Location</Text>
                                <Text style={{ width: '13%', fontSize: 10, textAlign: 'left', flexShrink: 0, fontWeight: "bold" }}>Joined Date</Text>
                                <Text style={{width: '13%', textAlign: 'right', fontSize: 10, flexShrink: 0, fontWeight: "bold" }}>Professional Fee %</Text>
                                <Text style={{ width: '12%', textAlign: 'right', fontSize: 10, flexShrink: 0, fontWeight: "bold" }}>Billable CTC</Text>
                                <Text style={{ width: '14%', textAlign: 'right', fontSize: 10, flexShrink: 0, fontWeight: "bold" }}>Billable Amount</Text>
                            </>}
                    </View>
                    <View style={styles.tableBody}>
                        {invoiceCandidateData ?
                            <>
                                {invoiceCandidateData?.map((row, index) => {
                                    return (
                                        <View key={index} style={styles.tableRow}>
                                            <Text style={styles.tableCell}>{`${row?.first_name} ${row?.last_name}`}</Text>
                                            <Text style={styles.tableCell}>{row?.job_title}</Text>
                                            <Text style={{width: '12%', fontSize: 10, textAlign: 'left' , flexShrink: 0}}>{row?.job_location || "NA"}</Text>
                                            <Text style={{width: '16%', fontSize: 10, textAlign: 'left' , flexShrink: 0}}>{ConvertDate(row?.joined_date)}</Text>
                                            <Text style={{ width: '12.5%', fontSize: 10, flexShrink: 0, textAlign: "right", pr: 1 }}>{formatAmount(row?.billable_ctc)}</Text>
                                            <Text style={{ width: '15.5%', fontSize: 10, flexShrink: 0, textAlign: "right", pr: 1 }}>{formatAmount(row?.amount)}</Text>
                                        </View>
                                    )
                                }
                            )}
                            </> :
                            <>
                                {performaCandidateData?.map((row, index) => {
                                    return (
                                        <View key={index} style={styles.tableRow}>
                                            <Text style={{ width: '17%', fontSize: 10, textAlign: 'left', flexShrink: 0 }}>{row?.candidate_name}</Text>
                                            <Text style={{ width: '20%', fontSize: 10, textAlign: 'left', flexShrink: 0 }}>{row?.job_title}</Text>
                                            <Text style={{width: '11%', fontSize: 10, textAlign: 'left', flexShrink: 0 }}>{row?.job_location || "NA"}</Text>
                                            <Text style={{ width: '13%', fontSize: 10, textAlign: 'left', flexShrink: 0 }}>{row?.joined_date ? ConvertDate(row?.joined_date) : "NA"}</Text>
                                            <Text style={{ width: '13%', fontSize: 10, flexShrink: 0, textAlign: "right", pr: 1 }}>{row?.commission_percentage}</Text>
                                            <Text style={{ width: '12%', fontSize: 10, flexShrink: 0, textAlign: "right", pr: 1 }}>{formatAmount(row?.billable_ctc)}</Text>
                                            <Text style={{ width: '14%', fontSize: 10, flexShrink: 0, textAlign: "right", pr: 1 }}>{formatAmount(getAmount(row?.candidate_id))}</Text>
                                        </View>
                                    )
                                }
                                )}
                            </>}

                    </View>
                </View>
                {
                    data ?
                        <View style={styles.balanceContainer}>
                            <View style={styles.balance}>
                                <Text style={styles.balanceLabel}>Invoice Amount</Text>
                                <Text style={styles.balanceValue}>{formatAmount(data?.gst_breakup?.candidate_total) || 0}</Text>
                            </View>
                            {Number(data?.tds_percentage) > 0 && <View style={styles.balance}>
                                <Text style={styles.balanceLabel}>TDS</Text>
                                <Text style={styles.balanceValue}>{formatAmount(data?.tds_amount) || 0}</Text>
                            </View>}
                            {(data?.gst_breakup?.gst_applicable) && (
                                <>
                                    {Number(data?.gst_breakup?.igst) > 0 ? (
                                    // 🔹 Show IGST if available
                                        <View style={styles.balance}>
                                            <Text style={styles.balanceLabel}>IGST&nbsp;-&nbsp;{formatAmount(data?.gst_breakup?.igst) || 0}%</Text>
                                            <Text style={styles.balanceValue}>{formatAmount(data?.gst_breakup?.igst_total) || 0}</Text>
                                        </View>
                                    ) : (
                                    <>
                                        <View style={styles.balance}>
                                            <Text style={styles.balanceLabel}>CGST&nbsp;-&nbsp;{data?.gst_breakup?.cgst || 0}%</Text>
                                            <Text style={styles.balanceValue}>{formatAmount(data?.gst_breakup?.cgst_total) || 0}</Text>
                                        </View>
                                        <View style={styles.balance}>
                                            <Text style={styles.balanceLabel}>SGST&nbsp;-&nbsp;{data?.gst_breakup?.sgst || 0}%</Text>
                                            <Text style={styles.balanceValue}>{formatAmount(data?.gst_breakup?.sgst_total) || 0}</Text>
                                        </View>
                                    </>
                                    )}
                                </>
                            )}
                            <View style={styles.balance}>
                                <Text style={styles.balanceLabel}>Total Amount</Text>
                                <Text style={styles.balanceValue}>{formatAmount(data?.invoice_amount) || 0}</Text>
                            </View>
                        </View>
                        :
                        <View style={styles.balanceContainer}>
                            <View style={styles.balance}>
                                <Text style={styles.balanceLabel}>Invoice Amount</Text>
                                <Text style={styles.balanceValue}>{formatAmount(amountData?.[0]?.candidate_total) || 0}</Text>
                            </View>
                            {Number(amountData?.[0]?.tds_percentage) > 0 && <View style={styles.balance}>
                                <Text style={styles.balanceLabel}>TDS</Text>
                                <Text style={styles.balanceValue}>{formatAmount(amountData?.[0]?.tds_total) || 0}</Text>
                            </View>}
                            {
                                amountData?.[0]?.gst_applicable && (
                                <>
                                    {Number(amountData?.[0]?.igst) > 0 ? (
                                    // 🔹 Show IGST if available
                                        <View style={styles.balance}>
                                            <Text style={styles.balanceLabel}>IGST&nbsp;-&nbsp;{amountData?.[0]?.igst || 0}%</Text>
                                            <Text style={styles.balanceValue}>{formatAmount(amountData?.[0]?.igst_total) || 0}</Text>
                                        </View>
                                    ) : (
                                    <>
                                        <View style={styles.balance}>
                                            <Text style={styles.balanceLabel}>CGST&nbsp;-&nbsp;{amountData?.[0]?.cgst || 0}%</Text>
                                            <Text style={styles.balanceValue}>{formatAmount(amountData?.[0]?.cgst_total) || 0}</Text>
                                        </View>
                                        <View style={styles.balance}>
                                            <Text style={styles.balanceLabel}>SGST&nbsp;-&nbsp;{amountData?.[0]?.sgst || 0}%</Text>
                                            <Text style={styles.balanceValue}>{formatAmount(amountData?.[0]?.sgst_total) || 0}</Text>
                                        </View>
                                    </>
                                    )}
                                </>
                            )}
                            <View style={styles.balance}>
                                <Text style={styles.balanceLabel}>Total Amount</Text>
                                <Text style={styles.balanceValue}>{formatAmount(amountData?.[0]?.invoice_amt) || 0}</Text>
                            </View>
                        </View>
                }

                {/* Amount */}
                <View style={[styles.address, {paddingLeft: 8}]}>
                    <View style={[styles.addressContent,{ marginTop: 10 }]}>
                        <Text style={{ fontSize: 10}}>Amount</Text>
                        <Text style={{ fontSize: 10}}>:  {`${capitalizeWords(toWordsDynamic(Math.floor(data ? data?.invoice_amount || 0 : amountData?.[0]?.invoice_amt || 0)))} Only`}</Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 10 }]}>
                        <Text style={{ fontSize: 10}}>HSN Code</Text>
                        <Text style={{ fontSize: 10}}>:  {performaCandidateData ? performaCandidateData?.[0].hsn_code || "NA" : data?.hsn_code || "NA"}</Text>
                    </View>
                    {/* MSME */}
                    {orgConfigData?.msme_flag && 
                    <View style={[styles.address, { paddingRight: 8, marginTop: 12, marginBottom: 2}]}>
                        <View style={[styles.addressContent,{ marginTop: 0.5, borderWidth: 1, borderColor: "#000", padding: 4 }]}>
                            <Text style={{ fontSize: 9 }}>
                                Please note that we are a company registered under MSME vide Reference No.{" "}
                                <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 9, textDecoration: "underline", }}>
                                {orgConfigData?.msme_no}
                                </Text>{" "}
                                and request you to release the payment within the agreed time period
                            </Text>
                        </View>
                    </View>}
                    <Text style={{ fontSize: 10, marginTop: 10, fontFamily: 'Helvetica-Bold' }}>
                        For {userData?.company_full_name || "NA" }
                    </Text>
                    <View style={{ height: 70 }} />
                    <Text style={{ fontSize: 10, marginTop: 10 }}>
                        Authorized Signatory
                    </Text>
                </View>
                 <View style={[styles.address, {paddingLeft: 8, marginTop: 12}]}>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10,  fontFamily: 'Helvetica-Bold'}}>GST No.</Text>
                        <Text style={{ fontSize: 10}}> :  {orgConfigData?.gst_no || "NA"}</Text>
                    </View>
                </View>
                <View style={[styles.address, {paddingLeft: 8, marginTop: 4}]}>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 11, textDecoration: "underline"}}>
                            Bank Details
                        </Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10}}>Bank Name</Text>
                        <Text style={{ fontSize: 10}}>:  {orgConfigData?.bank_details?.bank_name || "NA"}</Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10}}>Branch</Text>
                        <Text style={{ fontSize: 10}}>:  {orgConfigData?.bank_details?.bank_branch || "NA"}</Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10}}>Account Holder</Text>
                        <Text style={{ fontSize: 10}}>:  {orgConfigData?.bank_details?.account_holder || "NA"}</Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10}}>Account Number</Text>
                        <Text style={{ fontSize: 10}}>:  {orgConfigData?.bank_details?.account_number || "NA"}</Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10}}>IFSC</Text>
                        <Text style={{ fontSize: 10}}>:  {orgConfigData?.bank_details?.ifsc_code || "NA"}</Text>
                    </View>
                    <View style={[styles.addressContent,{ marginTop: 0.5 }]}>
                        <Text style={{ fontSize: 10}}>Account Type</Text>
                        <Text style={{ fontSize: 10}}>:  {orgConfigData?.bank_details?.account_type?.name || "NA"}</Text>
                    </View>
                </View>
                {letterHeadData?.letterhead_footer && (
                    <View style={styles.footer1} fixed>
                        <Text>{letterHeadData?.letterhead_footer}</Text>
                        <View style={styles.footerPowered}>
                            <Text>Powered by</Text>
                            <Image style={styles.footerLogo} src={footerlogoSrc} />
                        </View>
                    </View>
                )}
            </Page>
        </Document>
    )

}
const formatAmount = (value) => {
  const num = Number(value);
  return isNaN(num) ? "0.00" : num?.toFixed(2);
};

export default AtsInvoicePdf;
